var jQuery = require('./jquery.js')
window.jQuery = window.$ = jQuery
module.exports = jQuery
